var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rental-sidebar-right" },
    [_c("sidebar"), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "admin-content-area",
        attrs: { id: "page-content-wrapper" }
      },
      [
        _c("div", { staticClass: "container-fluid xyz" }, [
          _c("div", { staticClass: "page-name" }, [_vm._v("Reservations")]),
          _vm._v(" "),
          _c("div", { staticClass: "admin-page-content" }, [
            _vm._v(
              "\n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n              Short term peak in business? Sporadic agricultural needs? Overall increased business demands? Replacement vehicle while your trucks are being repaired?\n              Velocity can help you meet all of your business needs. As your regional experts, we help you meet your business demands so you can take care of your customers. We offer reliable, well maintained, and safe vehicles. \n           "
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e18eca4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e18eca4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/Demo.vue
// module id = null
// module chunks = 